// ENTITY fr.gestionpial.pial.dto.EcoleListeDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class EcoleListeDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.EcoleListeDTO';

  idEcole: number | null = 0;
  nom: string | null = '';
  emailDirecteur: string | null = '';
  nbClasses: number | null = 0;
  nbNotifI: number | null = 0;
  nbNotifM: number | null = 0;
  totalAffecteMinutes: number | null = 0;
  totalAbsentMinutes: number | null = 0;
  totalBesoinMinutes: number | null = 0;
  dateDebut: Date | null = null;
  dateFin: Date | null = null;

  constructor(init?:Partial<EcoleListeDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.EcoleListeDTO'] = EcoleListeDTO;

fields['fr.gestionpial.pial.dto.EcoleListeDTO']  = {
    idEcole: 'java.lang.Integer',
    nom: 'java.lang.String',
    emailDirecteur: 'java.lang.String',
    nbClasses: 'java.lang.Integer',
    nbNotifI: 'java.lang.Integer',
    nbNotifM: 'java.lang.Integer',
    totalAffecteMinutes: 'java.lang.Integer',
    totalAbsentMinutes: 'java.lang.Integer',
    totalBesoinMinutes: 'java.lang.Integer',
    dateDebut: 'java.time.LocalDate',
    dateFin: 'java.time.LocalDate'
};
